import React, { memo, useCallback, useContext, useState } from 'react'
import { useSelector } from 'react-redux'
import QuickSearchButton from '../../../components/QuickSearch/QuickSearchButton'
import SettingsOutlinedIcon from '../../../assets/icons/SettingOutlined'
import { ExtraSmallButton } from '../../../components/custom'
import ChartSettingsDialogs from '../../../components/chartSettings/ChartSettingsDialogs'
import { selectChartType } from '../../../selectors/chart'
import { ChartType } from '../../../proto/generated/chart'
import { AppContext } from '../../../App'

export type StockBarChartOptionsProps = {
    disableChartOptions: boolean
    disableSettingsButton: boolean
    viewKey: string
}

const StockBarChartOptions: React.FC<StockBarChartOptionsProps> = ({
    disableChartOptions,
    disableSettingsButton,
    viewKey,
}) => {
    const appContext = useContext(AppContext)
    const [isSettingsOpen, setIsSettingsOpen] = useState(false)
    const chartType = useSelector(selectChartType(viewKey))

    const handleOpenSettings = useCallback(() => {
        const handledByWidget = appContext.dashboard?.openActiveWidgetSettings?.()
        if (!handledByWidget) {
            setIsSettingsOpen(true)
        }
    }, [appContext.dashboard])
    const handleCloseSettings = useCallback(() => setIsSettingsOpen(false), [])

    return (
        <>
            <QuickSearchButton disabled={disableChartOptions} />
            <span>
                <ExtraSmallButton
                    id="chart-settings-menu-button"
                    color="inherit"
                    onClick={handleOpenSettings}
                    disabled={disableSettingsButton}
                >
                    <SettingsOutlinedIcon />
                </ExtraSmallButton>
            </span>
            <ChartSettingsDialogs
                open={isSettingsOpen}
                onClose={handleCloseSettings}
                viewKey={viewKey}
                chartType={chartType ?? ChartType.CANDLESTICK}
            />
        </>
    )
}

export default memo(StockBarChartOptions)
